module.exports = __webpack_public_path__ + "img/pharma-bags.b918206b.png";